<template>
    <nav class="nav-mobile" :class="{ 'is-active': showMenu }">
        <user-avatar @click.native="closeMenu"/>
        <div class="nav-divider no-margin-top"></div>
        <router-link @click.native="closeMenu" v-for="(item, index) in menuItems" :key="index" class="btn has-icon-left stack-s" :to="item.route">
            <v-icon :icon="item.icon"></v-icon>
            {{item.label}}
        </router-link>
        <div class="nav-divider"></div>
        <a target="_blank" href="https://help.rebilly.com/rebilly-basics/getting-started-guide" class="btn has-icon-left stack-s">
            <v-icon icon="guides"></v-icon>
            Guides
        </a>
        <router-link @click.native="closeMenu" v-if="$auth.$pages['settings'].isAllowed" :to="{name: 'settings'}" class="btn has-icon-left stack-s">
            <v-icon icon="settings"></v-icon>
            Settings
        </router-link>
        <div class="nav-divider"></div>
        <sandbox-menu-item :mobile="true" @click.native="closeMenu"/>
        <div class="nav-divider"></div>
        <a @click="closeMenu" target="_blank" href="https://help.rebilly.com" class="btn has-icon-left stack-s">
            <v-icon icon="help"></v-icon>
            Help Center
        </a>
        <div class="nav-divider"></div>
        <router-link :to="{name: 'logout'}" class="btn has-icon-left" @click.native="closeMenu">
            <v-icon icon="logout" class="inline-s"/>Logout
        </router-link>
    </nav>
</template>

<script>
    import {
        vIconSprites, vIcon,
    } from '@/components/form';
    import UserAvatar from '@/modules/layouts/components/user-avatar';
    import SandboxMenuItem from '@/modules/layouts/components/sandbox-menu-item';
    import config from '@/common/config';

    export default {
        name: 'mobile-menu',
        props: {
            showMenu: {
                type: Boolean,
                default: false,
            },
            menuItems: {
                type: Array,
                default: [],
            },
        },
        components: {
            vIconSprites,
            vIcon,
            UserAvatar,
            // TODO: Verify this code
            config,
            SandboxMenuItem,
        },
        methods: {
            closeMenu() {
                this.$emit('close', true);
            },
        },
    };
</script>
